import React, { ReactElement } from "react";
import { ensure, getUsernameWithoutPrefix } from "sprint-common-web";

import { CloudFileListingItem } from "../types/CloudFileListingItem";

export const renderLastUpdatedBy = (item?: CloudFileListingItem): ReactElement | null => {
    ensure(item);

    if (!item.lastUpdatedBy) {
        return <>{"-"}</>;
    }

    return <>{getUsernameWithoutPrefix(item.lastUpdatedBy)}</>;
};
